import { render, staticRenderFns } from "./TrainingDuration.vue?vue&type=template&id=bcc88d26&scoped=true&"
import script from "./TrainingDuration.vue?vue&type=script&lang=js&"
export * from "./TrainingDuration.vue?vue&type=script&lang=js&"
import style0 from "./TrainingDuration.vue?vue&type=style&index=0&id=bcc88d26&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bcc88d26",
  null
  
)

export default component.exports